import { errorMessage } from "@streamoid/errors";
import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { getWorkspaces } from "../../utils/workspaces";
import { notify } from "../../utils/utils";
import "./style.css";

type AddWorkspaceModalProps = {
  organizationId: string;
  onClose: () => void;
  onAdd: (workspaceId: string) => Promise<any>;
};

export default function AddWorkspaceModal({
  organizationId,
  onClose,
  onAdd,
}: AddWorkspaceModalProps) {
  const [searchStr, setSearchStr] = useState("");
  const [workspaces, setWorkspaces] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [addingWorkspaceId, setAddingWorkspaceId] = useState<string | null>(
    null,
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setIsLoading(true);
      getWorkspaces(0, searchStr)
        .then((res) => {
          setWorkspaces(res?.data || []);
        })
        .catch((err) => {
          console.log(err);
          notify(errorMessage(err), "error");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }, 400);

    return () => clearTimeout(handler);
  }, [searchStr]);

  const handleAdd = (workspaceId: string) => {
    setAddingWorkspaceId(workspaceId);
    onAdd(workspaceId).finally(() => {
      setAddingWorkspaceId(null);
    });
  };

  return (
    <Modal onClose={onClose} modalStyle={{ width: "480px" }}>
      <div className="add-workspace-modal">
        <div className="add-workspace-modal-header">
          <div className="version-title">Add existing workspace</div>
          <button className="add-workspace-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <input
          className="version-input add-workspace-modal-search"
          value={searchStr}
          placeholder="Search workspaces by name..."
          onChange={(e) => setSearchStr(e.target.value)}
          autoFocus
        />

        <div className="add-workspace-modal-list">
          {isLoading ? (
            <div className="version-subtitle">Loading...</div>
          ) : workspaces.length === 0 ? (
            <div className="version-subtitle">No workspaces found.</div>
          ) : (
            workspaces.map((ws) => {
              const belongsToThisOrg =
                ws.organizationId && ws.organizationId === organizationId;
              const belongsToOtherOrg =
                ws.organizationId && ws.organizationId !== organizationId;

              return (
                <div key={ws._id} className="add-workspace-modal-row">
                  <div className="add-workspace-modal-row-info">
                    <div className="add-workspace-modal-row-name">
                      {ws.name}
                    </div>
                    <div className="add-workspace-modal-row-owner">
                      {ws.addedBy?.email || ""}
                    </div>
                  </div>
                  {belongsToThisOrg ? (
                    <span className="organizations-status-badge organizations-status-active">
                      Already added
                    </span>
                  ) : belongsToOtherOrg ? (
                    <span className="add-workspace-modal-other-org">
                      In another org
                    </span>
                  ) : (
                    <button
                      className="version-save-btn"
                      onClick={() => handleAdd(ws._id)}
                      disabled={addingWorkspaceId === ws._id}
                    >
                      {addingWorkspaceId === ws._id ? "Adding..." : "Add"}
                    </button>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    </Modal>
  );
}
